module.exports = __webpack_public_path__ + "static/media/login.cae557c2.png";